module.exports = __webpack_public_path__ + "static/img/bcc.c899f5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bcc.png
// module id = 4a1b
// module chunks = 1